var React = require('react');

function Bag (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-1383.000000, -13.000000)","stroke":"#3c3c3c","strokeWidth":"1.5"},React.createElement("g",{"transform":"translate(1384.000000, 14.000000)"},[React.createElement("path",{"d":"M7.93510665,12.1164916 L7.93510665,3.95367647 C7.93510665,1.81817227 9.660174,0.0159663866 11.8342872,2.66453526e-14 L11.9196262,2.66453526e-14 C14.0917075,0.0159663866 15.8167748,1.81817227 15.8167748,3.95367647 L15.8167748,12.1164916","key":0}),React.createElement("polygon",{"className":"fill","points":"22.0174674 24.6008088 1.73522676 24.6008088 1.4033219e-13 9.70816176 23.7526942 9.70816176","key":1})]))));
}

Bag.defaultProps = {"viewBox":"0 0 26 27"};

module.exports = Bag;

Bag.default = Bag;
